import { render, staticRenderFns } from "./CompetencesConnectedWithSkillsTab.vue?vue&type=template&id=17b5093c&scoped=true&"
import script from "./CompetencesConnectedWithSkillsTab.vue?vue&type=script&lang=js&"
export * from "./CompetencesConnectedWithSkillsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b5093c",
  null
  
)

export default component.exports